module.exports = __webpack_public_path__ + "media/images/lp_graduation-1-06cac8ecc65f8cb4fa78f0619227e702.webp";